const pl = {
  common: {
    startingHourLabel: "Start",
    endingHourLabel: "Koniec",
  },
  errors: {
    api:
      "Wystąpił błąd podczas komunikacji z serwerem. Spróbuj ponownie później.",
  },
};

export default pl;
